// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill";
import store, { UserRights } from './model/store'
Vue.config.productionTip = false
import { isProduct } from './config/config';

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(ElementUI, { locale })


import '@/assets/styles/index.scss' // global css

import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)



import './lf'
import './config/config'
import './request/language'
import './assets/My97DatePicker/WdatePicker.js'

// import '../static/UE/ueditor.config.js'
// import '../static/UE/ueditor.all.min.js'
// import '../static/UE/lang/en/en.js'
// import '../static/UE/ueditor.parse.min.js'



import linput from './components/input.vue';
Vue.component('l-input', linput)

import table_export from './components/table/table_export.vue';
Vue.component('l-table-export', table_export)



import loadButton from './components/loadButton.vue';
Vue.component('load-button', loadButton)

import form_group from './components/form/form_group.vue';
Vue.component('form-group', form_group)


import ltable_value from './components/table/table_value.vue';
Vue.component('l-table-value', ltable_value)

import lTableRowButtons from './components/table/table_TableRowButtons.vue';
Vue.component('l-table-rowbuttons', lTableRowButtons)


import popover_item from './components/popover_item.vue';
Vue.component('popover-item', popover_item)

import table_view from './components/table/table_view.vue';
Vue.component('l-table-view', table_view)

import table_page_view from './components/table/table_page_view.vue';
Vue.component('l-table-page-view', table_page_view)

// import page_search_table from './components/form/page_search_table.vue';
// Vue.component('page-search-table', page_search_table)

Vue.component('page-search-table', function (resolve) {
    // 这个特殊的 `require` 语法将会告诉 webpack
    // 自动将你的构建代码切割成多个包，这些包
    // 会通过 Ajax 请求加载
    require(['./components/form/page_search_table.vue'], resolve)
})


import form_list_item from './components/form/form_list_item.vue';
Vue.component('form-list-item', form_list_item)

import form_list from './components/form/form_list.vue';
Vue.component('form-list', form_list)

import formtext_list_item from './components/form/formtext_list_item.vue';
Vue.component('formtext-list-item', formtext_list_item)

import formtext_list from './components/form/formtext_list.vue';
Vue.component('formtext-list', formtext_list)


import LangSelect from './components/LangSelect.vue';
Vue.component('lang-select', LangSelect)

import UE from './components/UE.vue';
Vue.component('UE',UE)


Vue.component('l-myaddskumapping', function (resolve) {
    // 这个特殊的 `require` 语法将会告诉 webpack
    // 自动将你的构建代码切割成多个包，这些包
    // 会通过 Ajax 请求加载
    require(['./frame/Warehouse/MyAddSkuMapping.vue'], resolve)
})


Vue.filter('toSelect', function (value, forSelectStoreName) { //select对象 Select 绑定 Store的名称
    var obj = store.state[forSelectStoreName]
    for (var i in obj) {

        if (obj[i]['Value'] == value) {
            return obj[i]['Text']
        }
    }
    return value;
}
)


Vue.filter('GetString', function (value) { //CharacterParent对象
    var EN, CN, CN_T;
    if (value) {
        for (var i of value.Characters) {
            if (i.LanguageID == 1) {
                CN = i.Content;
            }

            if (i.LanguageID == 2) {
                CN_T = i.Content;
            }

            if (i.LanguageID == 3) {
                EN = i.Content;
            }
        }
    }

    if (CN) {
        return CN;
    }

    if (CN_T) {
        return CN_T;
    }

    if (EN) {
        return EN;
    }
}
)

function getScopeData(Scope, ScopeStr) {
    var aar = ScopeStr.split(".");
    var v = Scope;
    for (var i in aar) {
        var d = aar[i]
        if (aar[aar.length - 1] != d) {
            v = v[d]
        }
    }
    return { Scope: v, LastStr: aar[aar.length - 1] };
}


//日期
Vue.directive('datetime', {
    // 当绑定元素插入到 DOM 中。

    inserted: function (el, binding, vnode) {
        var gos = vnode.context;
        var d = function () {
            WdatePicker({
                el: el, lang: 'en', onpicked: function (dp) {
                    var Scope = getScopeData(gos.$data, binding.expression)
                    Vue.set(Scope.Scope, Scope.LastStr, el.value);
                }
            })
        };
        $(el).focus(d);
        $(el).click(d);
    }
    , update: function (el, binding, vnode) {
        var gos = vnode.context;
        var Scope = getScopeData(gos.$data, binding.expression)
        $(el).val(Scope.Scope[Scope.LastStr])

    }
})

//元素移动
Vue.directive('draggable', {
    inserted: function (el, binding, vnode) {

        var startX = binding.value.X,
        startY = binding.value.Y,

        x = binding.value.X,
        y = binding.value.Y;

        binding.value.$SX =0
        binding.value.$SY =0

        $(el).css({
            position: 'absolute',
            cursor: 'pointer',
            top: startY + 'px',
            left: startX + 'px'
        });

        function mousemove(event) {
            y = event.screenY - startY;
            x = event.screenX - startX;
            $(el).css({
                top: y + 'px',
                left: x + 'px'
            });

            // console.log("x:" +x)
            // console.log("y:" +y)
            // console.log("screenY:" +event.screenY)
            // console.log("screenX:" +event.screenX)

            binding.value.X = x;
            binding.value.Y = y;
        }

        function mouseup() {
            $(window.document).unbind('mousemove', mousemove);
            $(window.document).unbind('mouseup', mouseup);
        }

        $(el).bind('mousedown', function (event) {
            startX = event.screenX - x;
            startY = event.screenY - y;

            binding.value.$SX = binding.value.X
            binding.value.$SY = binding.value.Y

            $(window.document).bind('mousemove', mousemove);
            $(window.document).bind('mouseup', mouseup);

        });

    }
})

// router.afterEach((to, from) => {

//   gtag('set', 'page', to.path);
//   gtag('send', 'page');
// })

/* eslint-disable no-new */
window.MainVue = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
})


// if (isProduct) {
//     window.location.href = "#/Main"
//     window.onbeforeunload = function (params) {
//         return "  "
//     }
// }







// WEBPACK FOOTER //
// ./src/main.js